module.exports = __webpack_public_path__ + "media/精工工艺--窗户.da53c38b.mp4";